import {Component, ViewChild} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {LoadingController, ToastController} from '@ionic/angular';
import {BaseClass} from 'src/app/shared/classes/base';
import {ProcessConfig} from '../../shared/interfaces/process-config.interface';
import {ProcessStatusEnum} from '../../shared/interfaces/process.interface';
import {TranslationService} from '../../shared/services/translation.service';
import {Evaluation360Service} from '../360-evaluation.service';
import {Evaluated360User} from '../_interfaces/360-evaluation-user.interface';
import {AreaConfig} from '../_interfaces/area-config.interface';
import {Evaluation360UsersListComponent} from './users-list/users-list.component';

@Component({
    selector: 'app-360-evaluation-validation',
    templateUrl: './evaluation-validation.page.html',
    styleUrls: ['../360-evaluation.page.scss']
})
export class Evaluation360ValidationPage extends BaseClass {

    @ViewChild('userList', { static: true }) userList: Evaluation360UsersListComponent;

    public processConfig: ProcessConfig;
    public status: ProcessStatusEnum;
    public users: Array<Evaluated360User>;
    public selectedUser: Evaluated360User;
    public areas: Array<AreaConfig> = [];

    private _cycleId: number;

    constructor(
        protected _toastController: ToastController,
        protected _loadingController: LoadingController,
        protected _translationService: TranslationService,
        private _router: Router,
        private _activatedRoute: ActivatedRoute,
        private _evaluationService: Evaluation360Service
    ) {
        super(_toastController, _translationService);
        this._cycleId = parseInt(
            this._activatedRoute.snapshot.paramMap.get('cycleId'), 10
        );
    }

    ionViewWillEnter() {
        this._loadAllUsers();
    }

    public goBack(): void {
        this.selectedUser = undefined;
        this._router.navigate(['dashboard']);
    }

    public async selectUser(user: Evaluated360User): Promise<void> {
        await this._loadSelectedUsers(user);
    }

    public resetSelection(): void {
        this.selectedUser.status = ProcessStatusEnum.AllowedViewing;
        this.selectedUser = undefined;
        this.userList.selectedUserId = undefined;
    }

    public reopenUser(): void {
        this._loadAllUsers();
    }

    private async _loadAllUsers(): Promise<void> {
        this.selectedUser = undefined;
        this._evaluationService.getUsersFor360Validation(
            this._cycleId
        ).subscribe((response) => {
            this.users = response.data.users;
            this.processConfig = response.data.config;
            this.users = response.data.users;
            this.areas = response.data.config.areas;
        }, (error) => this.notifyError(error));
    }

    private async _loadSelectedUsers(user: Evaluated360User): Promise<void> {
        const loading = await this._loadingController.create();
        await loading.present();

        this._evaluationService.getSubordinateUsersFor360Validation(
            this._cycleId, user.userId
        ).subscribe((response) => {
            user.cycleParticipantId = response.data.cycleParticipantId;
            user.areaEvaluators = response.data.areaEvaluators;
            this.selectedUser = user;
            loading.dismiss();
        }, (error) => {
            this.notifyError(error);
            loading.dismiss();
        });
    }
}
